export const Location = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Layer_1"
      width={"8px"}
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      fill="white"
      style={{enableBackground:"new 0 0 512 512",transform:"rotate(135deg)"}}
    >
      <g>
        <polygon points="0,0 512,204.8 307.2,307.2 256,512  " />
      </g>
    </svg>
  );
};
